import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import TrashcanIcon from '@wix/da-ds/pkg/Icons/24x24/Trashcan';
import { PapiSellerDiscount } from '@wix/da-papi-types';
import { useDeleteDiscount } from '../../SellerDiscountModal/hooks';

interface Props {
  discount: PapiSellerDiscount;
}

const DeleteDiscountButton: FC<Props> = ({ discount }) => {
  const { t } = useTranslation();
  const { isBusy, deleteDiscount } = useDeleteDiscount();

  const onClick = () => {
    deleteDiscount(discount?.discountId);
  };

  return (
    <IconButton
      size="medium"
      variant="main"
      icon={TrashcanIcon}
      aria-label={t('common.delete')}
      title={t('common.delete')}
      onClick={onClick}
      disabled={isBusy}
    />
  );
};
DeleteDiscountButton.displayName = 'DeleteDiscountButton';

export default DeleteDiscountButton;
